// import React, { useState } from "react";
// import {
//   MdDashboard,
//   MdPayment,
//   MdBedroomParent,
//   MdOutlineMeetingRoom,
//   MdPeople,
//   MdKeyboardArrowDown,
// } from "react-icons/md";
// import "./AlumniSidebar.css";
// import { NavLink } from "react-router-dom";

// export default function AlumniSidebar({ isOpen, toggleSidebar, role }) {
//   const [activeItem, setActiveItem] = useState("Dashboard");
//   const [openDropdown, setOpenDropdown] = useState(null);
//   const status = sessionStorage.getItem("status");

//   // ============================
//   // ROLE-WISE MENUS
//   // ============================

//   const alumniMenu = [
//     { title: "Creation", icon: <MdDashboard />, path: "/alumni/creation" },
//     { title: "Dashboard", icon: <MdDashboard />, path: "/alumni/dashboard" },

//   ];

//   // SELECT MENU BASED ON ROLE
//   let menuItems = [];
//    if (role === "alumni") menuItems = alumniMenu;

//   const handleDropdownToggle = (title) => {
//     setOpenDropdown(openDropdown === title ? null : title);
//   };

//   return (
//     <>
//       <div
//         className={`overlay ${isOpen ? "show" : ""}`}
//         onClick={toggleSidebar}
//       />

//       <aside className={`sidebar ${isOpen ? "open" : ""}`}>
//         <div className="sidebar-header">
//           <span className="brand-text"></span>
//           <button className="close-btn" onClick={toggleSidebar}>✖</button>
//         </div>

//         <nav className="nav">
//           {menuItems.map((item) => (
//             <div key={item.title} className="menu-group">

//               {/* If item is direct link */}
//               {item.path ? (
//                 <NavLink
//                   to={item.path}
//                   className={({ isActive }) =>
//                     `nav-item ${isActive ? "active" : ""}`
//                   }
//                   onClick={() => {
//                     setActiveItem(item.title);
//                     toggleSidebar();
//                   }}
//                 >
//                   <div className="menu-left">
//                     <span className="icon">{item.icon}</span>
//                     <span className="text">{item.title}</span>
//                   </div>
//                 </NavLink>
//               ) : (
//                 <button
//                   className={`nav-item ${
//                     activeItem === item.title ? "active" : ""
//                   }`}
//                   onClick={() => {
//                     setActiveItem(item.title);
//                     handleDropdownToggle(item.title);
//                   }}
//                 >
//                   <div className="menu-left">
//                     <span className="icon">{item.icon}</span>
//                     <span className="text">{item.title}</span>
//                   </div>

//                   {item.subItems && (
//                     <MdKeyboardArrowDown
//                       className={`arrow ${openDropdown === item.title ? "rotate" : ""}`}
//                     />
//                   )}
//                 </button>
//               )}

//               {/* Dropdown */}
//               {item.subItems && openDropdown === item.title && (
//                 <div className="submenu flat">
//                   {item.subItems.map((sub) => (
//                     <NavLink
//                       key={sub.name}
//                       to={sub.path}
//                       className={({ isActive }) =>
//                         `submenu-item ${isActive ? "active" : ""}`
//                       }
//                       onClick={toggleSidebar}
//                     >
//                       <span className="submenu-dot">•</span>
//                       {sub.name}
//                     </NavLink>
//                   ))}
//                 </div>
//               )}
//             </div>
//           ))}
//         </nav>
//       </aside>
//     </>
//   );
// }

import React, { useState } from 'react'
import { MdDashboard, MdKeyboardArrowDown } from 'react-icons/md'
import './AlumniSidebar.css'
import { NavLink } from 'react-router-dom'

export default function AlumniSidebar({ isOpen, toggleSidebar, role }) {
  const [activeItem, setActiveItem] = useState('Dashboard')
  const [openDropdown, setOpenDropdown] = useState(null)

  // ============================
  // GET STATUS FROM SESSION
  // ============================
  const statusData = sessionStorage.getItem('alumniData')

  const parsedData = statusData ? JSON.parse(statusData) : null
  const status = parsedData?.status
  // ============================
  // ROLE + STATUS BASED MENUS
  // ============================
  let menuItems = []

  if (role == 'alumni') {
    if (status == 'new') {
      menuItems = [
        {
          title: 'Creation',
          icon: <MdDashboard />,
          path: '/alumni/creation',
        },
      ]
    }

    if (status == 'approved') {
      menuItems = [
        {
          title: 'Dashboard',
          icon: <MdDashboard />,
          path: '/alumni/dashboard',
        },
        {
          title: 'Job Post',
          icon: <MdDashboard />,
          path: '/alumni/job-post',
        },
        {
          title: 'Profile',
          icon: <MdDashboard />,
          path: '/alumni/profile',
        },
      ]
    }
  }

  const handleDropdownToggle = (title) => {
    setOpenDropdown(openDropdown === title ? null : title)
  }

  return (
    <>
      {/* Overlay */}
      <div
        className={`overlay ${isOpen ? 'show' : ''}`}
        onClick={toggleSidebar}
      />

      {/* Sidebar */}
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <span className="brand-text">Alumni Panel</span>
          <button className="close-btn" onClick={toggleSidebar}>
            ✖
          </button>
        </div>

        {/* Navigation */}
        <nav className="nav">
          {menuItems.map((item) => (
            <div key={item.title} className="menu-group">
              {/* Direct Link */}
              {item.path ? (
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `nav-item ${isActive ? 'active' : ''}`
                  }
                  onClick={() => {
                    setActiveItem(item.title)
                    toggleSidebar()
                  }}
                >
                  <div className="menu-left">
                    <span className="icon">{item.icon}</span>
                    <span className="text">{item.title}</span>
                  </div>
                </NavLink>
              ) : (
                <button
                  className={`nav-item ${
                    activeItem === item.title ? 'active' : ''
                  }`}
                  onClick={() => {
                    setActiveItem(item.title)
                    handleDropdownToggle(item.title)
                  }}
                >
                  <div className="menu-left">
                    <span className="icon">{item.icon}</span>
                    <span className="text">{item.title}</span>
                  </div>

                  {item.subItems && (
                    <MdKeyboardArrowDown
                      className={`arrow ${
                        openDropdown === item.title ? 'rotate' : ''
                      }`}
                    />
                  )}
                </button>
              )}

              {/* Dropdown (if any in future) */}
              {item.subItems && openDropdown === item.title && (
                <div className="submenu flat">
                  {item.subItems.map((sub) => (
                    <NavLink
                      key={sub.name}
                      to={sub.path}
                      className={({ isActive }) =>
                        `submenu-item ${isActive ? 'active' : ''}`
                      }
                      onClick={toggleSidebar}
                    >
                      <span className="submenu-dot">•</span>
                      {sub.name}
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>
      </aside>
    </>
  )
}
